import React, { useEffect, useState } from 'react';
import { useFormik } from "formik"
import { Form, Label, Row, Col, Input } from 'reactstrap';
import { MODE, MODIFICATION_TYPE } from 'helpers/sf_constants';
import { useSelector } from 'react-redux';
import SfLoadingSkeleton from 'components/Common/Loadings/SfLoadingSkeleton';
import { getPrimaryButtonClass } from 'helpers/sf_utils';
import _ from 'lodash';

const RequestHeaders = ({ integration_id, mode, initialState, onSubmitState, openNextAccordion }) => {

  const [requestHeadersState, setRequestHeadersState] = useState(initialState?.lead_integration?.lead_integration_req_headers ? [...initialState?.lead_integration?.lead_integration_req_headers] : [])

  useEffect(() => {
    if(initialState?.lead_integration?.lead_integration_req_headers?.length) {
      setRequestHeadersState([...initialState?.lead_integration?.lead_integration_req_headers])
    }
  }, [initialState?.lead_integration?.lead_integration_req_headers])

  const { lead_integration_loading } = useSelector(state => ({
    lead_integration_loading: state.Integration.loading,
  }))

  const addRequestHeaders = () => {
    const new_request_header = {
      key: "",
      value: "",
      modification_type: MODIFICATION_TYPE.new
    }
    setRequestHeadersState([...requestHeadersState, new_request_header])
  }

  const handleRequestHeaders = (event, index) => {
    const { value, name } = event.target;
    setRequestHeadersState(prevGroupMap => {
      const updateRowinputForm = _.cloneDeep(prevGroupMap)
      if (!!updateRowinputForm[index].id) {
        updateRowinputForm[index].modification_type = MODIFICATION_TYPE.update
      }
      updateRowinputForm[index][name] = value;
      return updateRowinputForm;
    })
  }

  const deleteRequestHeader = (event, index) => {
    setRequestHeadersState(prevGroupMap => {
      const updateRowinputForm = _.cloneDeep(prevGroupMap)
        updateRowinputForm[index].modification_type = MODIFICATION_TYPE.delete
      return updateRowinputForm;
    })
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      lead_integration_req_headers: []
    },
    onSubmit: (values, { resetForm }) => {
      const lead_integration = {
        lead_integration_req_headers: requestHeadersState.filter(reques_header => reques_header?.modification_type !== MODIFICATION_TYPE.delete || reques_header?.id)
      }
      if (mode === MODE.EDIT) {
        onSubmitState({ lead_integration })
      }
      if (mode === MODE.CREATE) {
        onSubmitState({ ...initialState, lead_integration: { ...initialState?.lead_integration, ...lead_integration } });
      }
      resetForm();
      openNextAccordion();
    },
  });

  let mapping_unique_index = 0;

  if (lead_integration_loading) {
    return <SfLoadingSkeleton rows={2} cols={2} />
  }

  return (
    <React.Fragment>
      <Form
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <Row className="d-flex align-items-center">
          <Col md={12} xl={12}>
            <p>
            Request Headers are a list of key/value pairs sent and received by both the client program and server on every HTTP request and response. They define how information sent/received through the connection are encoded
            </p>
            <div className="w-50">
              {requestHeadersState && requestHeadersState.map((reques_header, index) => {
                if(reques_header?.modification_type === MODIFICATION_TYPE.delete) {
                  return
                }
                return (
                  <Row className="d-flex align-items-center" key={index}>
                    {index == 0 ?
                    <>
                     <Col md={5}>
                        <Label for="connector_from_template" className="form-label font-weight-semibold">Key</Label>
                    </Col>
                    <Col md={5}>
                        <Label for="connector_from_template" className="form-label font-weight-semibold">Value</Label>
                    </Col> </> : "" }
                    <Col md={12}>
                      {mapping_unique_index++ > 0 ? <div className="font-weight-semibold my-2 fs-11">AND</div> : ""}
                    </Col>
                    <Col md={5}>
                      <div className="my-1">
                        <Input
                          className="form-control"
                          onChange={(e) => handleRequestHeaders(e, index)}
                          name="key"
                          value={reques_header.key}
                        />
                      </div>
                    </Col>
                    <Col md={5}>
                      <div className="my-1">
                        <Input
                          className="form-control"
                          onChange={(e) => handleRequestHeaders(e, index)}
                          name="value"
                          value={reques_header.value}
                        />
                      </div>
                    </Col>
                    <Col md={"auto"}>
                      <a className='mt-2' onClick={(e) => deleteRequestHeader(e, index)} id={`request_header${index}`}>
                        <i className="mdi mdi-close h3 pt-2"></i>
                      </a>
                    </Col>
                  </Row>
                )
              })}
            </div>
          </Col>
          <Col md={12} xl={12}>
            <div className="text-sfblue d-flex-inline align-items-center">
              <a onClick={addRequestHeaders} id="add-request-headers">
                <i className="bx bx-plus font-weight-semibold align-middle"></i>
                <label className="h6 mt-3 font-weight-semibold text-sfblue" style={{ cursor: "pointer" }}>Add</label>
              </a>
            </div>
          </Col>
          <Col md={12} xl={12}>
            <div className="my-3 flex-container space-between">
              <button className={`btn ${getPrimaryButtonClass()} flex-item`} type="submit" name="submit"> {false ? "Saving" : (mode === MODE.EDIT ? "Save" : "Continue")}</button>
              <button hidden={false ? false : true} className="btn btn-light ms-3 flex-item" type="button" onClick={validation.resetForm} name="cancel">Cancel</button>
            </div>
          </Col>
        </Row>
      </Form>
    </React.Fragment>
  )
}

export default RequestHeaders